import React, {Component} from 'react'
import './styles.scss';

class Checkbox extends Component {
    constructor(props) {
        super(props);
        let name = "";
        if (props.name) {
            name = props.name;
        } else {
            name = "cbx_" + Math.random().toString(36).substring(7);
        }
        let state = {
            checked: props.checked ? true : false,
            disabled: props.disabled ? true : false,
            name: name
        };

        this.state = state;
    }

    onChange() {
        if (this.state.disabled) return;
        let newChecked = !this.state.checked;
        this.setState({checked: newChecked}, () => {
            if (this.props.onChange) {
                this.props.onChange(newChecked);
            }
        })
    }

    value() {
        return this.state.checked;
    }

    render() {
        let className = "Checkbox";
        if (this.props.default) className += " default";
        return (
            <div className={className}>
                <input name={this.state.name}
                       id={this.state.name}
                       type="checkbox"
                       onChange={this.onChange.bind(this)}
                       checked={this.state.checked}
                       />

                <label htmlFor={this.state.name} className="label-new">{this.props.text}</label>
            </div>);
    }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/Checkbox/index.js